export const defaultSeoClientStatus = [
  { name: 'Aguardando' },
  { name: 'Pendente' },
  { name: 'Priorizado' },
  { name: 'Impeditivo' },
  { name: 'Implementado' },
  { name: 'Finalizado' },
];
